import * as Yup from 'yup';

export const otherForm = Yup.object({
  contentType: Yup.string().required('Content Type is requriqued').default('mslp'),
  contentTopic: Yup.string()
    .required('Free Form Content Request is required')
    .max(8000, 'Free Form Content Request must be less than 8000 characters')
    .min(5, 'Free Form Content Request must be more than 5 characters')
    .trim(),
  wordCount: Yup.number()
    .required('Word count is required')
    .max(2500, 'Word count must be less than 2500')
    .min(100, 'Word count must be more than 100'),
  executeCopyscapeSearch: Yup.boolean().optional()
});

export const initialValues = {
  contentTopic: '',
  wordCount: '',
  executeCopyscapeSearch: true
};
